import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de acaricidas microbiologicos
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarAcaricidasMicroBio(props) {
  useEffect(() => {
    const title = 'acaricidaMicroBio.cadastroDeAcaricidaMicroBio';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'acaricidas-microbiologicos'}
      insumoEnum={Insumo.ACARICIDA_MICROBIOLOGICO}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'acaricidaMicroBio.' +
          (props.match.params.id
            ? 'acaricidaMicroBioEditadoComSucesso'
            : 'acaricidaMicroBioCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'acaricidaMicroBio.' +
          (props.match.params.id
            ? 'falhaAoEditarAcaricidaMicroBio'
            : 'falhaAoCadastrarAcaricidaMicroBio')
      )}
      falhaCarregarMensagem={formatMessage('acaricidaMicroBio.falhaAoCarregarAcaricidaMicroBio')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarAcaricidasMicroBio));
